// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"h3-z","displaySixCardTiles":"i3-z"};